/** The part of a settled lead that decides which completion screen it gets. */
type LeadOutcome = {
  is_qualified: boolean;
  is_duplicate: boolean;
};

/**
 * Whether the call-back scheduler takes the completion screen over: the form schedules call backs,
 * and the lead is qualified without already being in the pipeline.
 *
 * Read in the two places that must never disagree — the completion builder, which renders the
 * scheduler, and the form client, which drops the form's own "Close" button because the scheduler
 * carries it on its success panel instead. A form that offered both would let a visitor leave
 * mid-booking with nothing scheduled.
 */
export function showsCallbackScheduler<Schedule>(
  schedule: Schedule | null | undefined,
  lead: LeadOutcome | null
): schedule is Schedule {
  return Boolean(schedule && lead?.is_qualified && !lead.is_duplicate);
}
